import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Integration } from '@utils/constants';

const initialState: Integration[] = [];

export const integrationsSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    initIntegrations: (_, action: PayloadAction<Integration[]>) => {
      return action.payload;
    },
    addIntegration: (state, action: PayloadAction<Integration>) => {
      return [...state, action.payload];
    },
    // Reemplaza el registro por id (el PUT devuelve el registro completo ya
    // mergeado server-side). Con `addIntegration` el mismo provider quedaría
    // DUPLICADO en el store y la card leería el primero (config vieja).
    updateIntegration: (state, action: PayloadAction<Integration>) => {
      return state.map((integration) => (integration.id === action.payload.id ? action.payload : integration));
    },
    removeIntegration: (state, action: PayloadAction<Integration>) => {
      return state.filter((integration) => integration.id !== action.payload.id);
    },
    reset: () => initialState,
  },
});
